import mainStyle from '../org-management.module.scss';

// Components
import MessageBoxGroup from 'components/MessageBoxGroup';
import Breadcrumbs from '../../../../components/Breadcrumb';
import PaginationContainer from 'components/PaginationContainer';

// Sub compoent
import OrgManagementTableToolbarBox from './OrgManagementTableToolbarBox';
import OrgManagementTable from './OrgManagementTable';
import ModalComponents from '../ModalComponents';

import { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import { cloneDeep, isNil, size } from 'lodash';

import { uiActions } from "stores/slice/ui";
import { loadGuiBootstarp, loadOrgBootstarp } from "stores/slice/fetchStatus";

import {
  defaultMessages,
  getDefaultModalStatus,
  defaultPagination
} from "../const";
import { messageKeyPrefix } from "utils/message.util";

import controller from './controller';

const defaultPathList = [
  { label: '6525f0afe7', isLink: false },
  { label: '85827d89ef', isLink: false }
];

const OrgManagement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { pageContext } = useSelector((store) => store);
  const info = controller.getInfo();

  const defaultModalStatus = getDefaultModalStatus(info);
  const [multiMessages, setMultiMessages] = useState(cloneDeep(defaultMessages));
  const [modalStatus, setModalStatus] = useState(cloneDeep(defaultModalStatus));
  const [searchOrg, setSearchOrg] = useState({});
  const [dataList, setDataList] = useState([]);
  const [pagination, setPagination] = useState(cloneDeep(defaultPagination));

  const getData = async ({ newSearchObj, newPagination }) => {
    try {
      dispatch(uiActions.showSpinner());
      const usePagination = newPagination || pagination
      const useSearchObj = newSearchObj || searchOrg
      // console.log(usePagination, useSearchObj)
      const { res, filter } = await controller.getDataList(info, usePagination, useSearchObj);

      if (usePagination.current < 2) usePagination.currentLength = res.total

      setPagination(usePagination);
      setDataList(res.data);
    } catch (error) {
      console.debug('org getData:', error);
    } finally {
      dispatch(uiActions.hideSpinner());
    }
  };

  const handleSearch = useCallback((searchParams) => {
    if (!info.isOrgUser) {
      const newSearchObj = {};
      for (const [fieldIndex, field] of Object.entries(searchParams)) {
        if (!isNil(field?.key) && size(field?.key) > 0) {
          newSearchObj[`${fieldIndex}Name`] = field?.key || '';
        }
      }
      setSearchOrg(newSearchObj);
      getData({ newSearchObj });
    }
  }, []);

  const handleChangePage = (currentPageNum) => {
    const copy = cloneDeep(pagination);
    copy.current = currentPageNum;
    if (!info.isOrgUser) {
      getData({ newPagination: copy })
    } else {
      setPagination(copy);
    }
  };

  const handleChangePageLimit = (currentPageNum) => {
    const copy = cloneDeep(pagination);
    copy.pageLimit = currentPageNum;
    setPagination(copy);
    if (!info.isOrgUser) {
      getData({ newPagination: copy })
    }
  };

  const handleModals = useCallback((params) => {
    // console.log('handleModals', params);
    const tmpModalStatus = { ...modalStatus };
    tmpModalStatus[params.modal].status = params.status;
    tmpModalStatus[params.modal].type = params.type;
    if (params.editObj)
      tmpModalStatus[params.modal].editObj = params.editObj;
    else
      delete tmpModalStatus[params.modal].editObj

    setModalStatus(tmpModalStatus);
  }, []);

  const submitModal = (result) => {
    // console.log('submitModal', result)
    const copy = cloneDeep(defaultMessages)
    if (!isNil(result?.error)) {
      copy.error = t(`${messageKeyPrefix.e.s}${result.error.code}`)
    } else {
      copy.success = t(`${messageKeyPrefix.s.c}1001`)
      dispatch(loadGuiBootstarp());
    }
    setMultiMessages(copy)
  }

  useEffect(() => {
    if (!isNil(pageContext)) {
      const newPagination = cloneDeep(pagination)
      newPagination.current = 1
      getData({ newPagination });
    }
  }, [pageContext]);

  return (
    <>
      <Breadcrumbs pathList={defaultPathList} />
      <div className={`layout-container layout-container--column layout-container--fluid ${mainStyle['org-management-msp']}`}>
        <MessageBoxGroup
          messages={multiMessages}
          onClose={type => setMultiMessages({ ...multiMessages, [type]: null })}
        />

        <OrgManagementTableToolbarBox {...{ info, handleSearch, modalStatus, handleModals, setMultiMessages }} />
        <OrgManagementTable {...{ info, dataList, pagination, searchOrg, handleModals }} />
        <PaginationContainer
          total={pagination?.currentLength || 0}
          isCurrentPageId={pagination?.current || 1}
          onPageChange={(currentPageNum) => {
            handleChangePage(currentPageNum);
          }}
          onEntryLimitChange={(currentPageNum) => {
            handleChangePageLimit(currentPageNum);
          }}
        />
        <ModalComponents {...{ info, modalStatus, handleModals, submitModal }} />
      </div>
    </>
  );
};

export default OrgManagement;
